export {
  default,
  default as useUpdateUserInformation,
} from "./useUpdateUserInformation";
